import { Categories } from "../category.type";

import ContributionStructureBarImage from "./images/contribution-structure-bar.svg";
import ContributionTimeColumnImage from "./images/contribution-time-column.svg";
import ContributionTimeColumnSingleImage from "./images/contribution-structure-column-single.svg";
import ContributionStackedWaterfallImage from "./images/contribution-stacked-waterfall.svg";
import ContributionLayeredWaterfallImage from "./images/contribution-layered-waterfall.svg";

import {
    ContributionLayeredWaterfallSampleData,
    ContributionStackedWaterfallSampleData,
    ContributionStructureBarCommentData,
    ContributionStructureBarSampleData,
    ContributionTimeColumnCommentData,
    ContributionTimeColumnSampleData,
    ContributionTimeColumnSingleCommentData,
    ContributionTimeColumnSingleSampleData,
} from "./contributionCategories.mock";
import { ChartType } from "@zebrabi/charts";

export const contributionCategories: Categories = [
    {
        displayName: "Single Series",
        charts: [
            {
                id: "contribution-structure-column-single",
                title: "Bridge chart",
                image: ContributionTimeColumnSingleImage,
                sampleData: ContributionTimeColumnSingleSampleData,
                commentData: ContributionTimeColumnSingleCommentData,
                tooltip:
                    "Assess the contribution of all parts to the subtotal and total value, display a starting and the resulting end value with the deviations in between for discrete items. Use for Contribution of Variances.",
                settings: {
                    chartType: ChartType.Waterfall,
                    showVerticalCharts: false,
                    invertedCategories: ["Material", "Personnel", "Freight", "Advertising", "Other OpEx", "Depreciation"],
                    resultCategories: ["EBIT 2018", "EBIT 2019", "EBIT FX'"],
                },
            },
            {
                id: "contribution-stacked-waterfall",
                title: "Stacked waterfall chart",
                image: ContributionStackedWaterfallImage,
                sampleData: ContributionStackedWaterfallSampleData,
                isMultiples: true,
                disabledComments: true,
                tooltip:
                    "Tracks how a starting value changes over time or across categories to reach a final total, while simultaneously breaking down those intermediate changes into sub-segments.",
                settings: {
                    chartType: ChartType.Waterfall,
                    resultCategories: ["EBITDA PY", "Adj. EBITDA PY 1", "Adj. EBITDA PY 2", "EBITDA AC"],
                    stackedChart: true,
                    differenceHighlight: false,
                },
            },
            {
                id: "contribution-layered-waterfall",
                title: "Layered waterfall chart",
                image: ContributionLayeredWaterfallImage,
                sampleData: ContributionLayeredWaterfallSampleData,
                isMultiples: true,
                disabledComments: true,
                tooltip:
                    "Runs a separate waterfall for each group and layers them on top of one another, so the shared result columns show the combined total while every layer keeps its own bridge from start to end.",
                settings: {
                    chartType: ChartType.LayeredWaterfall,
                    resultCategories: ["EBITDA", "EBIT", "Net Earnings", "Free Cash Flow"],
                    stackedChart: true,
                    differenceHighlight: false,
                },
            },
        ],
    },
    {
        displayName: "Multiple Series",
        charts: [
            {
                id: "contribution-time-column",
                title: "Horizontal waterfall chart",
                image: ContributionTimeColumnImage,
                sampleData: ContributionTimeColumnSampleData,
                commentData: ContributionTimeColumnCommentData,
                tooltip:
                    "Assess the contribution of all parts to the whole value with a waterfall chart, explain partial values with negative/positive columns or rows. Use for Contribution of Variances.",
                settings: {
                    chartType: ChartType.Waterfall,
                    showVerticalCharts: false,
                },
            },
            {
                id: "contribution-structure-bar",
                title: "Vertical waterfall chart",
                image: ContributionStructureBarImage,
                sampleData: ContributionStructureBarSampleData,
                commentData: ContributionStructureBarCommentData,
                tooltip:
                    "Vertical waterfall chart – Assess the contribution of all parts to the whole value with a waterfall chart, explain partial values with negative/positive columns or rows. Use for Contribution of Variances.",
                settings: {
                    chartType: ChartType.Waterfall,
                    showVerticalCharts: true,
                    chartLayout: "Waterfall",
                },
            },
        ],
    },
];
